import * as Styles from './PageHeader.styles';

export type PageHeaderProps = {
  /** The page title. */
  title: string;
  /** Optional action elements (buttons, dropdowns) rendered on the right. */
  actions?: React.ReactNode;
};

const PageHeader = function ({ title, actions }: PageHeaderProps): JSX.Element {
  return (
    <Styles.Wrapper>
      <Styles.Title>{title}</Styles.Title>
      {actions && <Styles.Actions>{actions}</Styles.Actions>}
    </Styles.Wrapper>
  );
};

export default PageHeader;
